var _metadata, _defs, _sodipodiNamedview, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "far",
    "data-icon": "image",
    className: "svg-inline--fa fa-image fa-w-16",
    role: "img",
    viewBox: "0 0 514 386",
    id: "svg3481",
    sodipodiDocname: "image-regular.svg",
    width: 514,
    height: 386,
    inkscapeVersion: "1.0.2 (1.0.2+r75+1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata3487"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3485"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#000000",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 2498,
    "inkscapeWindow-height": 1403,
    id: "namedview3483",
    showgrid: "false",
    "fit-margin-top": 1,
    "fit-margin-left": 1,
    "fit-margin-right": 1,
    "fit-margin-bottom": 1,
    inkscapeZoom: 1.96875,
    inkscapeCx: 257,
    inkscapeCy: 193,
    "inkscapeWindow-x": 62,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg3481"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(91, 91, 91, .2)",
    d: "M 465,1 H 49 C 22.49,1 1,22.49 1,49 v 288 c 0,26.51 21.49,48 48,48 h 416 c 26.51,0 48,-21.49 48,-48 V 49 C 513,22.49 491.51,1 465,1 Z m -6,336 H 55 a 6,6 0 0 1 -6,-6 V 55 a 6,6 0 0 1 6,-6 h 404 a 6,6 0 0 1 6,6 v 276 a 6,6 0 0 1 -6,6 z M 129,89 c -22.091,0 -40,17.909 -40,40 0,22.091 17.909,40 40,40 22.091,0 40,-17.909 40,-40 0,-22.091 -17.909,-40 -40,-40 z M 97,289 h 320 v -80 l -87.515,-87.515 c -4.686,-4.686 -12.284,-4.686 -16.971,0 L 193,241 153.485,201.485 c -4.686,-4.686 -12.284,-4.686 -16.971,0 L 97,241 Z",
    id: "path3479"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRegular);
export default __webpack_public_path__ + "static/media/image-regular.77e3c1b2a220ffc6dbb769771d67bb2e.svg";
export { ForwardRef as ReactComponent };